import { Col, DatePicker, Form, Input, Row } from 'antd';
import { Dayjs } from 'dayjs';
import dayjs from 'mixins/dayjsConfig';
import Button from 'mixins/ui/button/button';
import PartWrapper from 'mixins/ui/part-wrapper';
import React, { useState } from 'react';
import 'react-app-polyfill/stable';

import './ReferenceBookSearch.scss';

type Props = {
    code: string;
    data?: any[];
    loading: boolean;
    setLoading: (loading: boolean) => void;
    params: any;
    setParams: (data: any) => void;
};

const ReferenceBookSearch: React.FC<Props> = ({ code, loading, setLoading, setParams, params }) => {
    const [initialParams] = useState(params);
    const [form] = Form.useForm();

    const clearForm = () => {
        form.resetFields();
        setParams(initialParams);
    };

    const disabledDate = (current: Dayjs) => {
        return current.year() < 1900 || (current && current > dayjs().endOf('day'));
    };

    const onFinish = (value: any) => {
        setLoading(true);

        const data = value;

        if (data.a_in_date_of) {
            data.a_in_date_of = dayjs(value.a_in_date_of).format('YYYY-MM-DD');
        }

        if (data.a_in_date) {
            data.a_in_date = dayjs(value.a_in_date).format('YYYY-MM-DD');
        }

        Object.keys(data).forEach((key) => {
            if (typeof data[key] === 'string' && data[key].trim() === '') {
                delete data[key];
            }
        });

        setParams(data);
    };

    const getStyle = (code: string) => {
        return {
            width: code == 'tax_org' || code == 'ref_msu' ? 'auto' : '100%',
        };
    };

    return (
        <>
            <div
                className="find-reference"
                style={{
                    width:
                        code == 'tax_org' ||
                        code == 'ref_msu' ||
                        code == 'minimum_wage_ref' ||
                        code === 'penalty_coef'
                            ? '100%'
                            : '35%',
                    marginBottom: 20,
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                }}
            >
                {(code == 'tax_org' || code == 'ref_msu') && (
                    <Col
                        style={{
                            fontSize: 24,
                            marginTop: 35,
                        }}
                    >
                        Поиск по справочникам
                    </Col>
                )}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Row gutter={15}>
                        {(code == 'penalty_coef' ||
                            code == 'tax_classification' ||
                            code == 'tax_org' ||
                            code == 'ref_msu') && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label={code == 'tax_org' || code == 'ref_msu' ? 'Код' : 'КБК'}
                                    name={(code == 'ref_msu' ? 'a_in_code_so' : 'a_in_code') as any}
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {(code == 'penalty_coef' ||
                            code == 'tax_classification' ||
                            code == 'tax_org' ||
                            code == 'ref_msu') && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="Наименование"
                                    name={
                                        (code == 'ref_msu'
                                            ? 'a_in_name_ugd_ru'
                                            : 'a_in_name') as any
                                    }
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {(code == 'tax_org' || code == 'ref_msu') && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="БИН"
                                    name={
                                        (code == 'ref_msu' ? 'a_in_bin_so' : 'a_in_code_bi') as any
                                    }
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {code == 'ref_msu' && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="КОД ОГД"
                                    name="a_in_code_ugd"
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {code == 'tax_org' && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="РНН"
                                    name="a_in_rnn"
                                >
                                    <Input
                                        size="large"
                                        type="number"
                                        placeholder="Введите значение"
                                        onChange={(e) => {
                                            form.setFieldsValue({
                                                a_in_rnn: parseFloat(e.target.value),
                                            });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {code == 'penalty_coef' && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="Тип"
                                    name="a_in_type"
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {(code == 'penalty_coef' ||
                            code == 'refunding_rate' ||
                            code == 'mrp_ref' ||
                            code == 'minimum_wage_ref') && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="Дата"
                                    name={
                                        (code == 'mrp_ref' || code == 'minimum_wage_ref'
                                            ? 'a_in_date'
                                            : 'a_in_date_of') as any
                                    }
                                >
                                    <DatePicker
                                        size="large"
                                        format="DD.MM.YYYY"
                                        placeholder="Введите значение"
                                        disabledDate={disabledDate}
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {(code == 'mrp_ref' || code == 'minimum_wage_ref') && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="Значение"
                                    name="a_in_value"
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {code == 'refunding_rate' && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="Ставка"
                                    name="a_in_rate_value"
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                        {code == 'penalty_coef' && (
                            <Col style={getStyle(code)}>
                                <Form.Item
                                    label="Коэффициент"
                                    name="a_in_coef"
                                >
                                    <Input
                                        size="large"
                                        placeholder="Введите значение"
                                    />
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                    <Row
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Col
                            style={{
                                marginRight: 20,
                            }}
                        >
                            <Button onClick={clearForm}>Очистить</Button>
                        </Col>
                        <Col>
                            <Button
                                color="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                Найти
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
};

export default (props) => (
    <PartWrapper {...props}>
        <ReferenceBookSearch {...props} />
    </PartWrapper>
);
